<template>
    <div>
        <h3>{{title}}</h3>
        <hr/>
        <div class="row">
            <div class="col-md-4 form-group">
                <label class="font-weight-bold required" :for="'number' + _uid">{{ $t('contract.number') }}</label>
                <input type="text" class="form-control"
                       v-model="contract.number"
                       v-validate="'required'"
                       :name="'number' + _uid"
                       :data-vv-as="$t('contract.number')"
                       :id="'number' + _uid">
                <span class="text-danger" v-if="errors.has('number' + _uid)">{{ errors.first('number' + _uid) }}</span>
            </div>

            <div class="col-md-4 form-group">
                <label class="font-weight-bold required" :for="'name' + _uid">{{ $t('contract.name') }}</label>
                <input type="text" class="form-control"
                       v-model="contract.name"
                       v-validate="'required'"
                       :name="'name' + _uid"
                       :data-vv-as="$t('contract.name')"
                       :id="'name' + _uid">
                <span class="text-danger" v-if="errors.has('name' + _uid)">{{ errors.first('name' + _uid) }}</span>
            </div>

            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'subject' + _uid">{{ $t('contract.subject') }}</label>
                <input type="text" class="form-control" v-model="contract.subject" :id="'subject' + _uid">
            </div>

            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'validFrom' + _uid">{{ $t('contract.validFrom') }}</label>
                <div :id="'validFrom' + _uid">
                    <date-picker v-model="contract.validFromUtc">
                    </date-picker>
                </div>
            </div>
            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'validTo' + _uid">{{ $t('contract.validTo') }}</label>
                <div :id="'validTo' + _uid">
                    <date-picker v-model="contract.validToUtc">
                    </date-picker>
                </div>
            </div>
            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'conclusionDate' + _uid">{{ $t('contract.conclusionDate')
                    }}</label>
                <div :id="'conclusionDate' + _uid">
                    <date-picker v-model="contract.conclusionDate">
                    </date-picker>
                </div>
            </div>
            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :class="required? 'required':''" :for="'amount' + _uid">{{ $t('contract.amount') }}</label>
                <input type="text" class="form-control"
                       v-model="contract.amount"
                       v-validate="required? 'required':''"
                       :name="'amount' + _uid"
                       :data-vv-as="$t('contract.amount')"
                       :id="'amount' + _uid">
                <span class="text-danger" v-if="errors.has('amount' + _uid)">{{ errors.first('amount' + _uid) }}</span>
            </div>
            <div class="form-group col-md-12">
                <label class="font-weight-bold" :for="'description' + _uid">{{ $t('person.description') }}</label>
                <textarea rows="3" class="form-control" v-model="contract.description" :id="'description' + _uid"
                          :maxlength="maxCharacters"></textarea>
                <p>Остават Ви {{charactersRemaining}} символа.</p>
            </div>

            <div class="form-group col-md-12" v-if="showButton">
                <button type="button"
                        class="btn btn-danger"
                        @click="deleteContract">
                    <i class="fas fa-trash-alt"></i> {{ $t('buttons.delete.btnText') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from '@/components/datepicker/DatePicker';
    import { Contract } from '@/models/models';

    export default {
        inject: ['$validator'],
        components: {
            'date-picker': DatePicker
        },
        props: {
            contract: Contract,
            title: String,
            showButton: {
                Boolean,
                default: true
            },
            required: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                maxCharacters: 4000
            };
        },
        mounted() {
            this.$set(this.contract, 'uid', `contract${this._uid}`);
        },
        computed: {
            charactersRemaining: function () {
                return this.maxCharacters - this.contract.description.length;
            }
        },
        methods: {
            deleteContract: function () {
                this.$emit('deleted', this.contract);
            }
        }
    }
</script>

<style scoped>
</style>
